import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getUserDisplayName } from "@bw/shared/utils";

import type { PlatformUserDetail } from "../api";

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

/** Current ban state and the account's complete moderation history. */
export function UserModerationPanel({ user }: { user: PlatformUserDetail }) {
  return (
    <Paper component="section" variant="outlined" sx={{ p: 2.5 }}>
      <Typography component="h2" variant="h6" sx={{ fontWeight: 700 }}>
        Moderation
      </Typography>

      {user.active_ban ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          Active ban: {user.active_ban.reason}
        </Alert>
      ) : (
        <Typography color="text.secondary" variant="body2" sx={{ mt: 2 }}>
          No active bans.
        </Typography>
      )}

      {user.ban_history.length === 0 ? (
        <Typography color="text.secondary" variant="body2" sx={{ mt: 2 }}>
          No ban history.
        </Typography>
      ) : (
        <Stack divider={<Divider flexItem />} spacing={1.5} sx={{ mt: 2 }}>
          {user.ban_history.map((ban) => (
            <Box key={ban.ban_id} sx={{ py: 0.5 }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={0.5}
                sx={{
                  alignItems: { xs: "flex-start", sm: "baseline" },
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {ban.reason}
                </Typography>
                <Typography color="text.secondary" variant="caption">
                  {formatDateTime(ban.created_at)}
                </Typography>
              </Stack>
              <Typography color="text.secondary" variant="caption">
                Issued by{" "}
                {getUserDisplayName(ban.issued_by_display_name, ban.issued_by)}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
